module.exports = __webpack_public_path__ + "static/img/2.bbd4d33.png";


//////////////////
// WEBPACK FOOTER
// ./static/hz/2.png
// module id = mWnr
// module chunks = 202